<template>
<div>
    <div class="image" v-if="hydro">
        <img src="./gifs/hydro.gif">
    </div>
    <div class="image" v-if="accele">
        <img src="./gifs/accele.gif">
    </div>
    <div class="image" v-if="phrea">
        <img src="./gifs/phrea.gif">
    </div>
    <div class="image" v-if="airq">
        <img src="./gifs/airq.gif">
    </div>
</div>
</template>

<script>
    export default{
        name: 'LoadingAccele',

        props: {
            hydro: {
                default: false,
                type: Boolean
            },
            accele: {
                default: false,
                type: Boolean
            },
            phrea: {
                default: false,
                type: Boolean
            },
            airq: {
                default: false,
                type: Boolean
            }
        }
    };
</script>

<style scoped lang="scss">
    .image{
        position: absolute;
        display:flex;
        justify-content: center;
        align-items: center;
        width: 100vw;
        height: 100vh;
        left: 0px;
        background: $bg-extra-color-transparent;
        z-index: 5;
    }

    img{
        width: auto;
        max-height: 80%;
        opacity: 0.6;
    }
</style>